import { isEmpty, isNil } from 'ramda';

// eslint-disable-next-line import/prefer-default-export
export const isNullOrEmpty = object => isNil(object) || isEmpty(object);

const sizeSuffix = ['px', 'em', 'rem'];
export const computeSize = (propSize, enumToSizeMap, defaultSize) => {
  let computedSize = defaultSize;
  if (typeof propSize === 'number') {
    computedSize = `${propSize}px`;
  } else if (typeof propSize === 'string') {
    const mapped = enumToSizeMap?.[propSize.toUpperCase().trim()];
    if (mapped) {
      computedSize = mapped;
    } else if (sizeSuffix.some(s => propSize.endsWith(s))) {
      computedSize = propSize;
      // eslint-disable-next-line no-restricted-globals
    } else if (!isNaN(propSize) && propSize.length > 0) {
      computedSize = `${propSize}px`;
    }
  }
  return computedSize;
};

export const computeValue = (value, defValue, suffix) => {
  if (typeof value === 'number') {
    return `${value}${suffix}`;
  }
  if (typeof value === 'string') {
    if (value.endsWith(suffix)) {
      return value;
    }
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(value) && value.length > 0) {
      return `${value}${suffix}`;
    }
  }
  return defValue;
};

export const computeDeg = (value, defValue) => computeValue(value, defValue, 'deg');
